import React, {useEffect, useRef} from "react";

const InfiniteScroll = (props) => {
    const refer = useRef();

    useEffect(()=>{
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 1.0,
        };

        const observer = new IntersectionObserver(([entry])=> {
            if (entry.isIntersecting) {
                observer.disconnect()
                props.Listar()
                
            }
        }, options);
        observer.observe(refer.current);

        return () => {
            observer.disconnect();
        };
    },[props.Listar]);

    return <div ref={refer} />;
}

export default InfiniteScroll;